import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "pc_header" }
const _hoisted_2 = { class: "pc_header_content clear" }
const _hoisted_3 = {
  href: "/#/home",
  class: "header_content_logo fl"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "header_content_right clear fr" }
const _hoisted_6 = { class: "DropDown_content" }
const _hoisted_7 = { class: "header_content_phone fr" }

import {
  ref,
  reactive,
  watch,
  onMounted,
  onBeforeUnmount,
  watchEffect,
} from "vue";
// 导入Vue Router的useRoute钩子
import { useRoute } from "vue-router";
import { getPortalBaseInfo } from "@/api/contact";

// 获取当前路由对象

export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const route = useRoute();
const routeInfo = reactive({
  name: route.name,
});
const state = reactive({
  open: false,
  serveState: false,
  isMobile: false,
  isFixed: false,
});

// 基础信息
const data = reactive({});

// 获取基础信息
getPortalBaseInfo({ t: Date.now() }).then((res: any) => {
  if (res.code === 200) {
    Object.assign(data, res.data);
  }
});

const isSpecialRoute = (name: string) => {
  return ["service", "internetThings", "remoteSensing", "project"].includes(name);
};
const handleToggle = () => {
  state.open = !state.open;
};
const handleToggleService = () => {
  if (state.isMobile) {
    state.isFixed = true;
  } else {
    return;
  }
  state.serveState = !state.serveState;
};
const handleCloseService = () => {
  state.open = true;
  state.serveState = false;
  if (state.isMobile) {
    state.isFixed = false;
  }
};

const handleServeRoute = (name) => {
  state.open = false;
  state.serveState = false;
  if (isSpecialRoute(name)) {
    state.isFixed = true;
  }
};

// 定义处理视窗大小变化的函数
const handleWindowResize = () => {
  state.isMobile = window.innerWidth > 1065 ? false : true;
  console.log("state.isMobile:", state.isMobile);
};
onMounted(() => {
  state.isMobile = window.innerWidth > 1065 ? false : true;
  console.log("state.isMobile:***********************", state.isMobile);
  window.addEventListener("resize", handleWindowResize);
  // 直接监听route.name变化，无须指定getter和setter
  watchEffect(() => {
    // let routerList = [
    //   "home",
    //   "about",
    //   "service",
    //   "internetThings",
    //   "remoteSensing",
    //   "project",
    //   "case",
    //   "contact",
    // ];
    routeInfo.name = route.name;

    let saveState = ["service", "internetThings", "remoteSensing", "project"].includes(
      route.name
    );
    if (saveState && state.isMobile == false) {
      state.open = true;
      // state.serveState = false;
      state.isFixed = true;
    }
  });
});
// 在组件卸载时移除 resize 事件监听器，避免内存泄漏
onBeforeUnmount(() => {
  window.removeEventListener("resize", handleWindowResize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['circle', { expand: state.open }])
    }, null, 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _createElementVNode("img", {
          draggable: "false",
          src: data.companyIconUrl
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(['menu fl clear', { on: state.open }])
        }, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              class: _normalizeClass(['fl', { on: routeInfo.name === 'home' }, { animate: state.open }])
            }, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleServeRoute('home'))),
                href: "/#/home",
                class: "menu_title",
                style: _normalizeStyle({
                  display: state.isMobile && (state.serveState ? 'none' : 'block'),
                })
              }, "首页", 4)
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(['fl', { on: routeInfo.name === 'about' }, { animate: state.open }])
            }, [
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleServeRoute('about'))),
                href: "/#/about",
                class: "menu_title",
                style: _normalizeStyle({
                  display: state.isMobile && (state.serveState ? 'none' : 'block'),
                })
              }, "关于我们", 4)
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass([
                'fl',
                {
                  on:
                    routeInfo.name === 'service' ||
                    routeInfo.name === 'internetThings' ||
                    routeInfo.name === 'remoteSensing' ||
                    routeInfo.name === 'project',
                },
                { animate: state.open },
              ])
            }, [
              _createElementVNode("a", {
                href: "javascript:;",
                class: "menu_title service_items",
                onClick: handleToggleService,
                style: _normalizeStyle({
                  display: state.isMobile && (state.serveState ? 'none' : 'block'),
                })
              }, "服务项目", 4),
              _createElementVNode("div", {
                class: _normalizeClass([
                  'DropDown clear',
                  {
                    on: state.isMobile
                      ? state.isFixed && state.serveState
                      : state.isFixed && isSpecialRoute(routeInfo.name),
                    in: state.isMobile ? false : !state.isFixed && state.serveState,
                  },
                ])
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (handleServeRoute('service'))),
                    href: "/#/service",
                    class: _normalizeClass(['fl', { on: routeInfo.name === 'service' }])
                  }, _cache[8] || (_cache[8] = [
                    _createElementVNode("dd", { class: "projectIconfont" }, [
                      _createElementVNode("i", {
                        class: "iconfont icon-fangan",
                        style: {"font-size":"28px"}
                      })
                    ], -1),
                    _createElementVNode("dt", null, "一站式服务", -1)
                  ]), 2),
                  _createElementVNode("a", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (handleServeRoute('internetThings'))),
                    href: "/#/internetThings",
                    class: _normalizeClass(['fl', { on: routeInfo.name === 'internetThings' }])
                  }, _cache[9] || (_cache[9] = [
                    _createElementVNode("dd", { class: "projectIconfont" }, [
                      _createElementVNode("i", {
                        class: "iconfont icon-a-genggaosugengwendingdeduxiangzhuanxiandaikuan",
                        style: {"font-size":"28px"}
                      })
                    ], -1),
                    _createElementVNode("dt", null, "物联网接入", -1)
                  ]), 2),
                  _createElementVNode("a", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (handleServeRoute('remoteSensing'))),
                    href: "/#/remoteSensing",
                    class: _normalizeClass(['fl', { on: routeInfo.name === 'remoteSensing' }])
                  }, _cache[10] || (_cache[10] = [
                    _createElementVNode("dd", { class: "projectIconfont" }, [
                      _createElementVNode("i", {
                        class: "iconfont icon-yaoganfuwu",
                        style: {"font-size":"28px"}
                      })
                    ], -1),
                    _createElementVNode("dt", null, "遥感服务", -1)
                  ]), 2),
                  _createElementVNode("a", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (handleServeRoute('project'))),
                    href: "/#/project",
                    class: _normalizeClass(['fl', { on: routeInfo.name === 'project' }])
                  }, _cache[11] || (_cache[11] = [
                    _createElementVNode("dd", { class: "projectIconfont" }, [
                      _createElementVNode("i", {
                        class: "iconfont icon-xiangmuguanli",
                        style: {"font-size":"28px"}
                      })
                    ], -1),
                    _createElementVNode("dt", null, "项目管理", -1)
                  ]), 2)
                ]),
                (state.isMobile && state.serveState)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: handleCloseService,
                      class: "DropDown_close iconfont"
                    }, _cache[12] || (_cache[12] = [
                      _createElementVNode("i", { class: "iconfont icon-chacha" }, null, -1)
                    ])))
                  : _createCommentVNode("", true)
              ], 2)
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(['fl', { on: routeInfo.name === 'case' }, { animate: state.open }])
            }, [
              _createElementVNode("a", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (handleServeRoute('case'))),
                href: "/#/case",
                class: "menu_title",
                style: _normalizeStyle({
                  display: state.isMobile && (state.serveState ? 'none' : 'block'),
                })
              }, "案例展示", 4)
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass([
                'fl',
                { on: routeInfo.name === 'contact' },
                { animate: state.open },
              ])
            }, [
              _createElementVNode("a", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (handleServeRoute('contact'))),
                href: "/#/contact",
                class: "menu_title",
                style: _normalizeStyle({
                  display: state.isMobile && (state.serveState ? 'none' : 'block'),
                })
              }, "联系我们", 4)
            ], 2)
          ])
        ], 2),
        _createElementVNode("div", _hoisted_7, [
          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "iconfont" }, [
            _createElementVNode("i", { class: "iconfont icon-dadianhua" })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(data.companyTel), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['burger fr', { open: state.open }]),
        onClick: handleToggle
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(['x ', { 'collapse rotate30 rotate45': state.open }])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(['y ', { collapse: state.open }]),
          style: _normalizeStyle({ display: state.open ? 'none' : 'block' })
        }, null, 6),
        _createElementVNode("div", {
          class: _normalizeClass(['z ', { 'collapse rotate150 rotate135': state.open }])
        }, null, 2)
      ], 2)
    ])
  ]))
}
}

})